import {
  NAV_HIDE_TAB,
  NAV_SHOW_TAB,
  NAV_SET_ROUTE,
  NAV_CHANGE_APP_STATE,
  NAV_SEE_ACTION_AGAIN,
  NAV_CHANGE_FIELD,
} from "./constants";

export const changeNavField = (payload: {
  scrollTop?: boolean;
  safeAreaTopColor?: string;
  safeAreaBottomColor?: string;
  isTopSafeAreaHidden?: boolean;
}) => {
  return {
    type: NAV_CHANGE_FIELD,
    payload,
  };
};

// utilisé ?
export const hideTab = () => {
  return {
    type: NAV_HIDE_TAB,
  };
};

// utilisé ?
export const showTab = () => {
  return {
    type: NAV_SHOW_TAB,
  };
};

// string ?
export const setRoute = payload => {
  return {
    type: NAV_SET_ROUTE,
    payload,
  };
};

export const changeAppState = (payload: string) => {
  return {
    type: NAV_CHANGE_APP_STATE,
    payload,
  };
};

// utilisé ?
export const seeActionAgain = payload => {
  return {
    type: NAV_SEE_ACTION_AGAIN,
    payload,
  };
};
